import { setActiveHeroTileColor } from './Color';
import { isTargetHeroDead } from './index';
import { spawnCommandButtons } from './Spawn';

// Initialize turn order of heros in this scene
export function initHeroTurnOrder() {
  this.herosTurnOrder = this.heros.sort((a, b) =>
    a.orderStrength > b.orderStrength ? -1 : 1,
  );
  this.activeHero = this.herosTurnOrder[0]; // eslint-disable-line prefer-destructuring
  this.debugLabel.text = `Active: ${this.activeHero.name}`;
  this.isMovable = true;
  setActiveHeroTileColor.call(this);
  spawnCommandButtons.call(this); // TODO: check if you are the active hero
}

// Set active hero in next turn
export function turnNextHero() {
  if (!this.herosTurnOrder) {
    return;
  }

  this.herosTurnOrder.push(this.herosTurnOrder.shift());
  const nextHero = this.herosTurnOrder[0];
  if (isTargetHeroDead.call(this, nextHero)) {
    turnNextHero.call(this);
    return;
  }

  this.activeHero = nextHero;
  this.debugLabel.text = `Active: ${this.activeHero.name}`;
  this.isMovable = true;
  setActiveHeroTileColor.call(this);
  spawnCommandButtons.call(this); // TODO: check if you are the active hero
}
